@if(isUniversalLoaded){<router-outlet></router-outlet>}